<app-hero></app-hero>
<section class="startup-expertise-area pt-60 pt-md-50 pt-sm-40 pb-60 pb-md-50 pb-sm-40">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 m-auto text-center">
        <div class="section-title-wrap layout--2">
          <h3>Catalogación de Inmuebles del Centro Histórico del Cusco</h3>
          <p class="mb-0">
            El Centro Histórico del Cusco se encuentra dividido en 09 Sectores de gestión,
            que contiene a los cuatro barrios tradicionales (barrios de Santa Ana, San Cristóbal, San Pedro y San Blas),
            el Núcleo del Centro Histórico y cuatro sectores con potencial de organización (Santo Domingo - San Agustín,
            Pumacchupan - Av. Pardo - Tres Cruces, Almudena y Mesa Redonda); haciendo un total de nueve sectores definidos por la
            variable histórica, organización social y proximidad física con la finalidad de lograr la participación social, vecinal y
            democrática de la población en la gestión del CHC.
          </p>
        </div>
      </div>
      <!-- End Section title -->
    </div>
    <div class="row align-items-center mtm-50">
      <div class="col-lg-4 col-md-6 order-1 order-lg-0">
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">1</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-01</h3>
            <p class="m-0">
              Conserva la traza urbana inca, alberga evidencia arqueológica prehispánica y de transición junto a inmuebles tipo
              casa patio declarados patrimonio monumental (PM-I) e inmuebles con valor patrimonial individual (PI-II).
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">2</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-02</h3>
            <p class="m-0">
              Muestra significativa presencia de evidencias arqueológicas en su disposición original, y reutilizadas e inmuebles tipo
              huerto declarados patrimonio monumental (PM-I) e inmuebles con valor patrimonial individual (PI-II), Este sector presenta cualidades paisajísticas.
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">3</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-03</h3>
            <p class="m-0">
              De traza urbana inca, alberga una mayor concentración de evidencia arqueológica prehispánica y de transición junto a inmuebles tipo casa patio con
              valor patrimonial monumental (PM-I) y patrimonial individual (PI-II) e inmuebles con valor contextual (VC-III),
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">4</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-04</h3>
            <p class="m-0">
              El barrio de San Blas es un sector de pendiente topográfica moderadamente empinada con cualidades paisajísticas alberga elementos arqueológicos en su
              disposición original y reutilizada e inmuebles tipo casa patio y casa huerto con valor contextual (VC-III) y con algún elemento artístico y/o patrimonial (EP-IV)
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">5</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-05</h3>
            <p class="m-0">
              El barrio de Santa Ana Presenta cualidades paisajísticas, trama urbana heterogénea con pendiente topográfica fuertemente inclinada en el sector de la quebrada de
              Saphy y moderadamente inclinada en el resto, alberga evidencia arqueológica prehispánica en su disposición original y reutilizada e inmuebles tipo casa patio con
              valor patrimonial individual (PI-II) y valor contextual (VC-III), así como algunos inmuebles con algún elemento artístico y/o patrimonial (EP-IV) e inmuebles
              contemporáneos sin valor específico o sin construir (SV-V). El sector presenta riesgos de erosión superficial y erosión por cárcavas en la ladera del río Saphy.
            </p>
          </div>
        </div>
      </div>
      <div class="col-lg-4 order-0 order-lg-1 my-auto pt-50">
        <figure class="video-area-wrap">
          <img src="assets/img/mapa-sectores-gestion-centro-historico.jpg" alt="Video" />
          <figcaption>
            <a class="btn-video-popup" data-toggle="modal" data-target="#exampleModal"><i class="fa fa-search"></i></a>
          </figcaption>
        </figure>
      </div>
      <!-- Modal -->
      <div class="modal fade" id="exampleModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-dialog-centered modal-xl" role="document">
          <div class="modal-content">
            <div class="modal-header text-center">
              <h5 class="modal-title text-center" id="exampleModalLabel">Mapa de Sectores del Centro Histórico del Cusco
              </h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <embed src="assets/pdf/tomo-1/PP-02 SECTORES PARA LA GESTION.pdf" type="application/pdf" width="100%"
                height="600px" />
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 order-2">
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">6</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-06</h3>
            <p class="m-0">
              Alberga evidencia arqueológica prehispánica original y reutilizada, concentrando un mayor porcentaje de
              inmuebles tipo casa patio de valor patrimonial individual (PI-II) y con valor contextual (VC-III) y, en menor cantidad,
              inmuebles sin valor patrimonial específico o sin construir (SV-V) de pendiente topográfica que va desde fuertemente
              inclinada (8%-15%) a moderadamente empinada (15%-25%) en algunas arterias como avenida Alta y calle Fierro.
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">7</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-07</h3>
            <p class="m-0">
              Alberga evidencia arqueológica reutilizada, presenta mayor densidad habitacional y carácter comercial, la pendiente
              topográfica varia entre llana, ligeramente inclinada y moderadamente inclinada, tiene una trama urbana heterogénea,
              alberga edificaciones republicanas y contemporáneas con valor contextual (VC-III) y en mayor cantidad edificaciones
              catalogadas como inmuebles sin valor específico o sin construir (SV-V).
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">8</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-08</h3>
            <p class="m-0">
              Destacan inmuebles de valor monumental (PM-I) e individual (PI-II) correspondientes a la Plazoleta Santiago, Plazoleta
              Belén y Plazoleta Almudena alberga evidencia arqueológica reutilizada, inmuebles tipo casa patio con valor contextual
              (CH- VC) y contemporáneos sin valor patrimonial específico en superficie o sin construir (SV-V), con pendiente topográfica
              fuertemente inclinada (8-15%) en la calle Almudena y llana en las plazoletas de Belén, Santiago y Almudena.
            </p>
          </div>
        </div>
        <div class="single-desc-item-wrap layout--2 d-flex">
          <span class="desc-number">9</span>
          <div class="busi-fea-info">
            <h3>Denominación: SG-09</h3>
            <p class="m-0">
              Sector con cualidades paisajísticas, alberga significativa evidencia arqueológica prehispánica en su disposición original
              y reutilizada, además de terrazas y evidencia del Qhapaq Ñan, así como la iglesia y el convento de La Recoleta y las huaca
              de Teteqaqa y Mesa Redonda aparte de algunos inmuebles sin valor patrimonial específico (SV-V).
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<section class="testimonial-area bg-img mt-40 mt-md-40 mt-sm-30" data-bg="assets/img/fondo-sectores.jpg">
  <div class="container">
    <div class="row">
      <div class="col-lg-9 m-auto">
        <h3 class="mb-40" style="color:white !important;">Sectores de Gestión</h3>
        <div class="testimonial-content-wrap">
          <div class="ht-slick-slider-wrapper">
            <div class="ht-slick-slider"
              data-slick='{"slidesToShow": 1, "arrows": true, "prevArrow": ".prev-arrow", "nextArrow": ".next-arrow" ,"autoplay": "true"}'>
              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-01/mdc-gch-compania-de-jesus-ioarr-2021.jpg" alt="Testimonial">
                    </figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-01</h4>
                    <h3 class="client-name mb-30" style="color:white !important;">Barrio del Núcleo del Centro Histórico
                    </h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">El núcleo de la ciudad nace en nuestro antiguo Awkaypata
                    y convertido hoy en plaza mayor, es un lugar donde viajeros de todos los tiempos rinden su admiración y reconocimiento
                    a las grandezas del hombre.<br>
                    Compuesto de las antiguas canchas incaicas y sobre ellas, los monumentos que son testimonio del sincretismo que nos envuelve,
                    se presenta con un respetable pasado de varios siglos.
                    </p>
                  </div>
                </div>
              </div>

              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-02/mdc-gch-templo-san-cristobal-frontis-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-02</h4>
                    <h3 class="client-name mb-30" style="color:white !important;">Barrio de San Cristobal</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">Desde la plaza mayor de Cusco se puede
                      apreciar en la parte elevada un singular barrio.<br> San Cristóbal, cuyo nombre obedece a su
                      templo construido inicialmente en el siglo XVI, en la actualidad representa uno de los barrios más
                      antiguos de la ciudad Imperial. </p>
                  </div>
                </div>
              </div>

              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-03/mdc-gch-templo-koricancha-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-03</h4>
                    <h3 class="client-name mb-30" style="color:white !important;">Santo Domingo y San Agustin</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">El templo más célebre del Tahuantinsuyo fue
                    el Coricancha y fue el lugar donde nació política y religiosamente el gran estado incaico. Inspiró a los
                    cronistas a envolverse de imaginación desbordada debido a las riquezas que ambicionaban en el siglo XVI.  <br>
                      Sobre sus bases se instaló el convento de Santo Domingo y en la actualidad se le aprecia por su
                      hermosa arquitectura y su honda historia. </p>
                  </div>
                </div>
              </div>
              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-04/mdc-gch-calles-barrio-san-blas-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-04</h4>
                    <h3 class="client-name mb-30" style="color:white !important;">San Blas y Rimacpampa</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">El barrio de San Blas antiguamente
                      se llamaba Tococachi y desde el tiempo de los incas hasta nuestros días ha mantenido su
                      continuidad histórica,
                      siendo un barrio de artesanos. <br> Compuesto de antiguas calles y piedra labradas en distintos
                      periodos, se muestra
                      imponente en la parte elevada de la ciudad y está ubicado en dirección al Antisuyo.</p>
                  </div>
                </div>
              </div>

              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-05/mdc-gch-cuesta-del-barrio-de-san-blas-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-05</h4>
                    <h3 class="client-name mb-30" style="color:white !important;">Santa Ana</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">Antiguamente llamado Carmenca y
                    ubicado al noroeste de la ciudad y en dirección del camino al Chinchaysuyo, este barrio presenció
                    la resistencia del ataque de los chancas así como el asedio de los españoles. <br>Producto de ello, la calle conquista es
                      testimonio de este y otros acontecimientos.</p>
                  </div>
                </div>
              </div>

              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-06/mdc-gch-templo-de-san-pedro-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-06</h4>
                    <h3 class="client-name mb-30" style="color:white !important;">San Pedro</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">El tradicional barrio de San Pedro se encuentra al noroeste de la ciudad.<br>
                    En este espacio en 1556, el capitán Sebastián Garcilaso de la Vega fundó un hospital, al que se nombró “Hospital de Naturales”.<br>
                    Más adelante, en 1688, Andrés de Mollinedo reconstruyó el templo. Se dice que para su edificación se usaron piedras de las
                    andenerías de los andenes de Picchu. </p>
                  </div>
                </div>
              </div>
              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-07/mdc-gch-paccha-del-sector-pumacchupam-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-07</h4>
                    <h3 class="client-name mb-30" style="color:white !important;"> Pumacchupan, Av. Pardo y Tres Cruces
                    </h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">Este sector alberga tres importantes estructuras coloniales fundadas entre
                    los siglos XVI y XVII y cuenta con un vasto depósito de conocimiento que muy bien los vecinos han sabido mantener.<br> Anteriormente,
                    en tiempo de los incas, se encontraban pasando el río Chunchullmayo y hoy convertido hoy en avenida Ejercito, se le puede apreciar pasando
                    los puentes que llevan los nombres de algunos de sus templos.</p>
                  </div>
                </div>
              </div>
              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-08/mdc-gch-hospital-antonio-lorena-ingreso-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-08</h4>
                    <h3 class="client-name mb-30" style="color:white !important;"> Almudena, Belén y Santiago</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">Este sector alberga tres importantes
                      estructuras coloniales fundadas entre los siglos XVI y XVII
                      y cuenta con un vasto depositario de conocimiento que muy bien los vecinos han sabido mantener.
                      Anteriormente, en tiempo de los incas, se encontraban pasando
                      el rio Chunchullmayo y hoy convertido hoy en avenida Ejercito, se le puede apreciar pasando los
                      puentes que llevan los nombres de algunos de sus templos.</p>
                  </div>
                </div>
              </div>

              <div class="single-testimonial-wrap layout--2">
                <div class="row">
                  <div class="col-md-6 text-center">
                    <figure class="author-thumb text-center ml-50"><img
                        src="assets/img/barrios/sector-09/mdc-gch-senor-de-teteqaqa-ioarr-2021.jpg"
                        alt="Testimonial"></figure>
                  </div>
                  <div class="col-md-6">
                    <h4 style="color:white !important;">SG-09</h4>
                    <h3 class="client-name mb-30" style="color:white !important;"> Totora Paccha, Mesa Redonda y
                      Teteqaqa</h3>
                    <p style="font-size: 16px; font-weight: 200; color: #d1d1d1;">En el tiempo de los incas la
                      admiración y el respeto que se sintió al paisaje natural se vio
                      reflejado en las obras que realizaron, poniendo a la piedra como parte de su tótem organizador del
                      mundo. <br>La extirpación de idolatrías iniciada en el siglo
                      XVI hizo lo suyo, sin embargo, estas estructuras líticas mantienen códigos ancestrales que ninguna
                      guerra ha podido vencer. En ese sentido podemos encontrar
                      las huacas de Teteqaqa y Totorapaccha, en dirección al cuadrante del Antisuyu. </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="ht-slick-nav"><button class="prev-arrow"><i class="tri-o-prev-arrow"
                  style="color:white !important;"></i></button> <button class="next-arrow"><i class="tri-o-next-arrow"
                  style="color:white !important;"></i></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<div class="freelancer-service-area bg-offwhite pt-120 pt-md-80 pt-sm-60 pb-120 pb-md-80 pb-sm-60" style="background-image: url('/assets/img/fondo-componentes.png'); background-size: cover;
background-position: center;">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">
        <div class="section-title-wrap layout--3">
          <h2>COMPONENTES DEL TRABAJO DE LA IOARR</h2>
        </div>
        <p style="margin-top: -30px !important; margin-bottom: 30px">“OPTIMIZACIÓN DEL SISTEMA DE INFORMACIÓN DEL
          SERVICIO DE CATALOGACIÓN DE INMUEBLES DEL CENTRO HISTÓRICO, <br>DISTRITO DE CUSCO, PROVINCIA CUSCO,
          DEPARTAMENTO CUSCO”,</p>
      </div>
    </div>
    <div class="row mtn-30">
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-laptop" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Componente de Sistemas/GIS</h3>
            <p>Encargado de la automatización de fichas de catalogación del Centro Histórico del Cusco,
              mediante el desarrollo de un software de migración de fichas excel a una base de datos; desarrollo del
              software de catalogación de fichas,
              verificación de fichas, seguimiento de observaciones, impresión de fichas y preservación de la
              información;
              Generación de planimetría según las características de la catalogación y desarrollo del portal web de la
              catalogación de inmuebles y patrimonio inmaterial.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-film" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Componente Social</h3>
            <p>Se realizó el registro de más de 71 expresiones culturales con la participación de diferentes actores
              sociales, teniendo como resultado entrevistas a
              profundidad que nos permiten conocer sus actividades
              mediante la web y la publicación del libro:
              “El centro del Cusco: Morada de historia y cultura viva” los saberes y conocimientos de los actores
              sociales del Centro Histórico del Cusco. Así mismo
              se genero la producción de videos, fotografías y narraciones de las mismas.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-check-square-o" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">Componente de Verificación</h3>
            <p>Se cumplió con la actividad que se refiere a la Verificación y contrastación de Fichas impresas y
              digitales de catalogación en un total 14,256 FICHAS
              (Ficha de registro Arquitectura, Ficha de registro fotográfico de Arquitectura, Ficha de registro
              Arqueológico, Ficha de registro fotográfico de Arqueología,
              Ficha de registro Histórico, Ficha de registro legal, planos y descripciones de ambientes urbanos) de
              acuerdo a la catalogación de inmuebles urbanos, religiosos
              y ambientes urbanos del centro histórico del Cusco.</p>
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="service-item-wrap service-item-3">
          <div class="service-item-icon"><i class="fa fa-edit" style="color: white;"></i></div>
          <div class="service-item-desc">
            <h3 style="color: white;">componente de Catalogación</h3>
            <p>Se cumplió con la elaboración de 50 fichas de catalogación de Inmuebles no Catalogados ANC, priorizando
              la catalogación de predios en el siguiente orden:
              declarados monumentos, con valor patrimonial, valor contextual, algún elemento patrimonial; los cuales se
              ubicaron en los Sectores de Gestión SG-0I Núcleo 5
              predios, SG-02 San Cristóbal 7 predios, SG-03 Santo Domingo 3 predios, SG-04 San Blas 11 predios, SG-05
              Santa Ana 2 predios, SG-06 San Pedro 10 predios, SG-07
              Pumacchupan 11 predios y SG-08 1 predio.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="page-wrapper">
  <article class="port-details-page-wrap">
      <div class="port-details-header">
          <div class="ht-slick-slider portfolio-thumbnail-inner" data-slick='{"slidesToShow": 5, "responsive": [{"breakpoint": 991,"settings": {"dots": false,"slidesToShow": 3}}, {"breakpoint": 575,"settings": {"slidesToShow": 2}}]}'>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/residencia/ioarr-gch-01.jpg" class="btn-img-gallery">
                      <img src="assets/img/residencia/ioarr-gch-01.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-02.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-02.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                  <a href="assets/img/residencia/ioarr-gch-03.jpg" class="btn-img-gallery">
                      <img src="assets/img/residencia/ioarr-gch-03.jpg" alt="Portfolio">
                  </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-04.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-04.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-08.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-08.jpg" alt="Portfolio">
                </a>
              </figure>
              <!-- <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-05.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-05.jpg" alt="Portfolio">
                </a>
              </figure>
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-06.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-06.jpg" alt="Portfolio">
                </a>
              </figure> -->
              <figure class="port-details-thumb-item">
                <a href="assets/img/residencia/ioarr-gch-07.jpg" class="btn-img-gallery">
                    <img src="assets/img/residencia/ioarr-gch-07.jpg" alt="Portfolio">
                </a>
              </figure>

          </div>
      </div>
  </article>
</div>
<!-- <div class="brand-logo-wrapper">
  <div class="container">
    <div class="row">
      <div class="col-md-4 text-center">
        <a href="https://cusco.gob.pe" target="_blank"><img src="assets/img/Logo-MPC-1.png" alt="Logo Municipalidad" height="80px"></a>
      </div>
      <div class="col-md-4 text-center">
        <a href="http://catalogacion.cusco.gob.pe/home"><img src="assets/img/logo-gerencia.png" alt="Logo Gerencia de Centro Histórico" height="100px"></a>
      </div>
      <div class="col-md-4 text-center">
        <a href="http://catalogacion.cusco.gob.pe/home"><img src="assets/img/logo-tika.png" alt="Logo Gestión" height="75px" class="mt-10"></a>
      </div>
    </div>
  </div>
</div> -->

<iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3879.360358420384!2d-71.98018918460401!3d-13.513463090502063!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x916dd7f071c1e139%3A0x6424a302c3d64e51!2sGerencia%20de%20Centro%20Hist%C3%B3rico!5e0!3m2!1ses-419!2sus!4v1628709299338!5m2!1ses-419!2sus"
  width="100%" height="450" style="border:0;" allowfullscreen="" loading="lazy"></iframe>
